// VOBVOROT COMPLETE EFFECTS - Maximum Elements from Original Site

(function() {
  'use strict';

  // ==================== MATRIX RAIN EFFECT ====================
  function initAdvancedMatrix() {
    let canvas = document.getElementById('matrix-canvas');
    if (!canvas) {
      canvas = document.createElement('canvas');
      canvas.id = 'matrix-canvas';
      canvas.style.cssText = 'position:fixed;top:0;left:0;width:100%;height:100%;z-index:-1;pointer-events:none;opacity:0.15;';
      document.body.insertBefore(canvas, document.body.firstChild); // Insert at the beginning
    }

    const ctx = canvas.getContext('2d');
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;

    // Extended matrix characters including Cyrillic and Japanese
    const matrix = "VOBVOROT EXVICPMOUR アニメ 東京 サイバー МАТРИЦА КОД УКРАИНА ヴィンテージ カスタム 0123456789@#$%^&*()";
    const matrixArray = matrix.split("");
    const fontSize = 14;
    const columns = canvas.width / fontSize;
    const drops = [];

    // Initialize drops
    for(let x = 0; x < columns; x++) {
      drops[x] = Math.floor(Math.random() * -100);
    }

    // Different colors for variety
    const colors = ['#00FFFF', '#FF1493', '#8A2BE2', '#39FF14'];

    function draw() {
      ctx.fillStyle = 'rgba(0, 0, 0, 0.04)';
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      ctx.font = fontSize + 'px JetBrains Mono, monospace';

      for(let i = 0; i < drops.length; i++) {
        const text = matrixArray[Math.floor(Math.random() * matrixArray.length)];
        ctx.fillStyle = colors[Math.floor(Math.random() * colors.length)];
        ctx.fillText(text, i * fontSize, drops[i] * fontSize);

        if(drops[i] * fontSize > canvas.height && Math.random() > 0.975) {
          drops[i] = 0;
        }
        drops[i]++;
      }
    }

    setInterval(draw, 35);

    window.addEventListener('resize', () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    });
  }

  // ==================== CUSTOM CURSOR WITH ADVANCED TRAIL ====================
  function initAdvancedCursor() {
    // Don't initialize custom cursor on mobile devices
    if (window.innerWidth <= 768) {
      return;
    }

    // Remove default cursor
    document.documentElement.style.cursor = 'none';

    // Create main cursor - HIDDEN INITIALLY
    const cursor = document.createElement('div');
    cursor.id = 'custom-cursor';
    cursor.style.cssText = `
      position: fixed;
      width: 20px;
      height: 20px;
      border: 2px solid #FF1493;
      border-radius: 50%;
      pointer-events: none;
      z-index: 10000;
      mix-blend-mode: screen;
      transition: transform 0.1s;
      opacity: 0;
    `;
    document.body.appendChild(cursor);

    // Create cursor dot - HIDDEN INITIALLY
    const cursorDot = document.createElement('div');
    cursorDot.style.cssText = `
      position: fixed;
      width: 4px;
      height: 4px;
      background: #00FFFF;
      border-radius: 50%;
      pointer-events: none;
      z-index: 10001;
      opacity: 0;
    `;
    document.body.appendChild(cursorDot);

    // Trail container
    const trailContainer = document.createElement('div');
    trailContainer.id = 'cursor-trail-container';
    document.body.appendChild(trailContainer);

    let mouseX = 0, mouseY = 0;
    let cursorX = 0, cursorY = 0;
    let trailIndex = 0;
    let cursorShown = false; // Flag to track if cursor has been shown

    document.addEventListener('mousemove', (e) => {
      mouseX = e.clientX;
      mouseY = e.clientY;

      // Show cursor on first mouse movement
      if (!cursorShown) {
        cursor.style.opacity = '1';
        cursorDot.style.opacity = '1';
        cursorShown = true;
      }

      // Create trail with rainbow colors
      if (trailIndex % 2 === 0) {
        const trail = document.createElement('div');
        const colors = ['#FF1493', '#00FFFF', '#8A2BE2', '#39FF14', '#FFFF00'];
        trail.style.cssText = `
          position: fixed;
          width: 8px;
          height: 8px;
          background: ${colors[trailIndex % colors.length]};
          border-radius: 50%;
          pointer-events: none;
          left: ${mouseX}px;
          top: ${mouseY}px;
          z-index: 9999;
          animation: fadeOut 1s forwards;
        `;
        trailContainer.appendChild(trail);
        setTimeout(() => trail.remove(), 1000);
      }
      trailIndex++;
    });

    // Smooth cursor animation
    function animateCursor() {
      const dx = mouseX - cursorX;
      const dy = mouseY - cursorY;

      cursorX += dx * 0.15;
      cursorY += dy * 0.15;

      cursor.style.left = cursorX - 10 + 'px';
      cursor.style.top = cursorY - 10 + 'px';

      cursorDot.style.left = mouseX - 2 + 'px';
      cursorDot.style.top = mouseY - 2 + 'px';

      requestAnimationFrame(animateCursor);
    }
    animateCursor();

    // Click effects
    document.addEventListener('mousedown', () => {
      cursor.style.transform = 'scale(1.5)';
      cursor.style.borderColor = '#00FFFF';
    });

    document.addEventListener('mouseup', () => {
      cursor.style.transform = 'scale(1)';
      cursor.style.borderColor = '#FF1493';
    });
  }

  // ==================== FLOATING PARTICLES ====================
  function initParticles() {
    const particleContainer = document.createElement('div');
    particleContainer.id = 'particle-container';
    particleContainer.style.cssText = 'position:fixed;top:0;left:0;width:100%;height:100%;pointer-events:none;z-index:1;';
    document.body.appendChild(particleContainer);

    function createParticle() {
      const particle = document.createElement('div');
      const size = Math.random() * 5 + 2;
      const colors = ['#FF1493', '#00FFFF', '#8A2BE2', '#39FF14'];

      particle.style.cssText = `
        position: absolute;
        width: ${size}px;
        height: ${size}px;
        background: ${colors[Math.floor(Math.random() * colors.length)]};
        border-radius: 50%;
        left: ${Math.random() * window.innerWidth}px;
        top: ${window.innerHeight + 10}px;
        animation: floatUp ${Math.random() * 5 + 5}s linear;
        opacity: ${Math.random() * 0.7 + 0.3};
      `;

      particleContainer.appendChild(particle);

      setTimeout(() => particle.remove(), 10000);
    }

    // Create particles periodically
    setInterval(createParticle, 300);
  }

  // ==================== KONAMI CODE + SECRET FEATURES ====================
  function initKonamiCode() {
    const konamiCode = ['ArrowUp', 'ArrowUp', 'ArrowDown', 'ArrowDown',
                        'ArrowLeft', 'ArrowRight', 'ArrowLeft', 'ArrowRight',
                        'b', 'a'];
    let konamiIndex = 0;
    let secretActivated = false;

    document.addEventListener('keydown', (e) => {
      if (e.key === konamiCode[konamiIndex]) {
        konamiIndex++;

        if (konamiIndex === konamiCode.length && !secretActivated) {
          activateSecretMode();
          secretActivated = true;
        }
      } else {
        konamiIndex = 0;
      }
    });

    function activateSecretMode() {
      // Add screen shake
      document.body.style.animation = 'konamiShake 0.5s ease-in-out';

      // Show secret message
      const secretMsg = document.createElement('div');
      secretMsg.style.cssText = `
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%) scale(0);
        background: linear-gradient(135deg, #FF1493, #8A2BE2, #00FFFF);
        padding: 40px;
        border-radius: 20px;
        z-index: 10002;
        color: white;
        font-size: 24px;
        text-align: center;
        box-shadow: 0 0 50px rgba(255,20,147,0.8);
        animation: secretAppear 0.5s forwards;
      `;
      secretMsg.innerHTML = `
        <h2 style="margin:0;text-shadow:2px 2px 4px rgba(0,0,0,0.5);">🎉 СЕКРЕТНЫЙ РЕЖИМ АКТИВИРОВАН! 🎉</h2>
        <p style="margin-top:20px;font-size:16px;">Ты нашёл пасхалку VOBVOROT!</p>
        <p style="margin-top:10px;font-size:14px;opacity:0.8;">Получи скидку 10% на следующую покупку 🎁</p>
      `;
      document.body.appendChild(secretMsg);

      setTimeout(() => {
        secretMsg.style.animation = 'secretDisappear 0.5s forwards';
        setTimeout(() => secretMsg.remove(), 500);
      }, 4000);

      // Add confetti effect
      createConfetti();
    }

    function createConfetti() {
      const confettiCount = 100;
      const colors = ['#FF1493', '#00FFFF', '#8A2BE2', '#39FF14', '#FFFF00'];

      for (let i = 0; i < confettiCount; i++) {
        const confetti = document.createElement('div');
        confetti.style.cssText = `
          position: fixed;
          width: 10px;
          height: 10px;
          background: ${colors[Math.floor(Math.random() * colors.length)]};
          left: ${Math.random() * window.innerWidth}px;
          top: -20px;
          z-index: 10001;
          animation: confettiFall ${Math.random() * 3 + 2}s linear;
        `;
        document.body.appendChild(confetti);

        setTimeout(() => confetti.remove(), 5000);
      }
    }
  }

  // ==================== SCROLL PROGRESS BAR ====================
  function initScrollProgress() {
    const progressBar = document.createElement('div');
    progressBar.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      height: 3px;
      background: linear-gradient(90deg, #FF1493, #00FFFF, #8A2BE2);
      z-index: 10001;
      width: 0%;
      transition: width 0.2s;
    `;
    document.body.appendChild(progressBar);

    window.addEventListener('scroll', () => {
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      const scrollHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
      const scrollPercent = (scrollTop / scrollHeight) * 100;
      progressBar.style.width = scrollPercent + '%';
    });
  }

  // ==================== FLOATING ICONS ====================
  function initFloatingIcons() {
    const icons = ['💎', '⚡', '🌸', '🎮', '🎨', '🌟', '💫', '🦄'];

    function createFloatingIcon() {
      const icon = document.createElement('div');
      icon.textContent = icons[Math.floor(Math.random() * icons.length)];
      icon.style.cssText = `
        position: fixed;
        font-size: 30px;
        left: -100px;
        bottom: ${Math.random() * window.innerHeight}px;
        z-index: 2;
        pointer-events: none;
        opacity: 0.6;
        animation: floatIcon ${Math.random() * 10 + 15}s linear;
      `;
      document.body.appendChild(icon);

      setTimeout(() => icon.remove(), 25000);
    }

    setInterval(createFloatingIcon, 3000);
  }

  // ==================== GLITCH TEXT EFFECT ====================
  function initGlitchText() {
    const glitchElements = document.querySelectorAll('.glitch');

    glitchElements.forEach(element => {
      const text = element.textContent;
      element.setAttribute('data-text', text);
    });
  }

  // ==================== MUSIC PLAYER ====================
  function initMusicPlayer() {
    // Check if music player should be shown
    const musicEnabled = localStorage.getItem('vobvorot-music-enabled') === 'true';

    const player = document.createElement('div');
    player.className = 'music-player';
    if (musicEnabled) player.classList.add('active');

    player.innerHTML = `
      <div style="display:flex;align-items:center;gap:10px;">
        <button id="music-toggle" style="background:#8A2BE2;color:white;border:none;padding:8px 16px;border-radius:5px;cursor:pointer;font-weight:bold;">
          🎵 ${musicEnabled ? 'Пауза' : 'Музыка'}
        </button>
        <span id="music-status" style="color:#00FFFF;font-size:12px;">${musicEnabled ? 'Играет...' : 'Остановлено'}</span>
      </div>
    `;
    document.body.appendChild(player);

    const audio = new Audio('https://example.com/vobvorot-theme.mp3'); // Replace with actual music URL
    audio.loop = true;

    if (musicEnabled) audio.play();

    document.getElementById('music-toggle').addEventListener('click', () => {
      if (audio.paused) {
        audio.play();
        localStorage.setItem('vobvorot-music-enabled', 'true');
        player.classList.add('active');
        document.getElementById('music-toggle').textContent = '🎵 Пауза';
        document.getElementById('music-status').textContent = 'Играет...';
      } else {
        audio.pause();
        localStorage.setItem('vobvorot-music-enabled', 'false');
        player.classList.remove('active');
        document.getElementById('music-toggle').textContent = '🎵 Музыка';
        document.getElementById('music-status').textContent = 'Остановлено';
      }
    });
  }

  // ==================== KEYBOARD CLICK SOUND ====================
  function initKeyboardSound() {
    document.addEventListener('keydown', function(e) {
      // Create simple click sound using Web Audio API
      const audioContext = new (window.AudioContext || window.webkitAudioContext)();
      const oscillator = audioContext.createOscillator();
      const gainNode = audioContext.createGain();

      oscillator.connect(gainNode);
      gainNode.connect(audioContext.destination);

      // Configure sound (short click)
      oscillator.frequency.value = 800;
      oscillator.type = 'sine';
      gainNode.gain.setValueAtTime(0.1, audioContext.currentTime);
      gainNode.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + 0.05);

      // Play
      oscillator.start(audioContext.currentTime);
      oscillator.stop(audioContext.currentTime + 0.05);
    });
  }

  // ==================== INITIALIZE ALL FEATURES ====================
  function initAllFeatures() {
    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    function init() {
      initAdvancedMatrix();
      initAdvancedCursor();
      // initParticles(); // DISABLED - floating particles
      // initKonamiCode(); // DISABLED - using new puzzle system without banner/confetti
      initScrollProgress();
      // initFloatingIcons(); // DISABLED - floating emoji
      initGlitchText();
      initKeyboardSound(); // Keyboard click on any key press
      // initMusicPlayer(); // Uncomment when you have music file
    }
  }

  // Start everything
  initAllFeatures();

  // Add required CSS animations
  const style = document.createElement('style');
  style.textContent = `
    @keyframes fadeOut {
      to { opacity: 0; transform: scale(0); }
    }

    @keyframes floatUp {
      0% { transform: translateY(0) rotate(0deg); opacity: 0; }
      10% { opacity: 1; }
      90% { opacity: 1; }
      100% { transform: translateY(-100vh) rotate(360deg); opacity: 0; }
    }

    @keyframes floatIcon {
      0% { transform: translateX(-100px) translateY(0) rotate(0deg); }
      100% { transform: translateX(calc(100vw + 100px)) translateY(-50px) rotate(360deg); }
    }

    @keyframes secretAppear {
      to { transform: translate(-50%, -50%) scale(1); }
    }

    @keyframes secretDisappear {
      to { transform: translate(-50%, -50%) scale(0); opacity: 0; }
    }

    @keyframes confettiFall {
      to { transform: translateY(100vh) rotate(720deg); }
    }

    @keyframes konamiShake {
      0%, 100% { transform: translateX(0); }
      10%, 30%, 50%, 70%, 90% { transform: translateX(-10px); }
      20%, 40%, 60%, 80% { transform: translateX(10px); }
    }
  `;
  document.head.appendChild(style);
})();
